import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import one from "assets/bgimage.png";
import sec from "assets/banner2.png";
import third from "assets/img3.png";
import fifth from "../../images/Big Data & Analyticsbanner.png";
import styles from "./ImageCarousel.module.css";

const slides = [
  {
    image: "https://wallpapercave.com/wp/wp6397615.png",
    alt: "AI & Machine Learning",
    tag: "Artificial Intelligence",
    title: (
      <>Automate & Advance with <span className={styles.highlight}>AI-Driven</span> Innovation</>
    ),
    description:
      "We design and deploy intelligent AI & Machine Learning solutions that automate complex workflows, uncover actionable insights, and accelerate enterprise innovation at scale.",
  },
  {
    image: "https://wallpapercave.com/wp/wp15397710.jpg",
    alt: "IT Services",
    tag: "Digital Engineering",
    title: (
      <>Excellent IT Services for <span className={styles.highlight}>Your Success</span></>
    ),
    description:
      "We collaborate with startups and enterprises to build secure, scalable digital products — delivering best-in-class engineering from concept to deployment.",
  },
  {
    image: "https://wallpaperaccess.com/full/186244.jpg",
    alt: "Web & Mobile Development",
    tag: "Product Development",
    title: (
      <>Web & Mobile <span className={styles.highlight}>Development</span> for the Future</>
    ),
    description:
      "Accelerate your business with responsive web and mobile applications. Our tailored solutions create seamless user experiences and enhance digital engagement.",
  },
  {
    image: "https://cygnotechlabs.com/wp-content/uploads/2023/11/DA-scaled.jpg",
    alt: "BI & Analytics",
    tag: "Data & Analytics",
    title: (
      <>Data-Driven Insights with <span className={styles.highlight}>BI & Analytics</span></>
    ),
    description:
      "Transform raw data into powerful insights. Our Business Intelligence and Analytics services help you make data-driven decisions that propel your business forward.",
  },
];

const ImageCarousel = () => {
  return (
    <Carousel
      className={styles.carouselImg}
      showArrows={true}
      autoPlay={true}
      infiniteLoop={true}
      showThumbs={false}
      showStatus={false}
      interval={5000}
      transitionTime={700}
      swipeable={true}
      emulateTouch={true}
    >
      {slides.map((slide, index) => (
        <div key={index} className={styles.slide}>
          <img src={slide.image} alt={slide.alt} className={styles.imgs} />
          <div className={styles.overlay} />
          <div className={styles.textContainer}>
            <span className={styles.tag}>{slide.tag}</span>
            <h2>{slide.title}</h2>
            <p>{slide.description}</p>
            <a href="#contact" className={styles.letsTalkButton}>
              Let's Talk
              <span className={styles.arrowB}>
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </a>
          </div>
        </div>
      ))}
    </Carousel>
  );
};

export default ImageCarousel;
